/**
 * Created by devmaster on 7/15/2017 AD.
 */
import React, { Component } from 'react'

export  default class MaintenanceCenterListRow extends Component{

  render(){
      var centerList;

      if (this.props.center_list.length === 0){
          centerList = <tr><td colSpan={5} className="text-center"><span className="text-danger">ไม่พบข้อมูล</span></td></tr>
      }else {

          centerList = this.props.center_list.map((center, index) => {
              return (
                  <tr key={index}>
                    <td>{ index+1 }</td>
                    <td>{ center.center_name }</td>
                    <td>{ center.center_address }</td>
                    <td>{ center.center_tel }</td>
                    <td className="text-right">
                      <button className="btn btn-sm btn-danger btn-md-width"
                              onClick={this.props.centersCallbacks.delete.bind(null,center)}
                      >
                        <i className="fa fa-remove"></i> ลบ</button>

                      <button className="btn btn-sm btn-warning btn-md-width"
                              onClick={this.props.centersCallbacks.edit.bind(null,center)}
                      >
                        <i className="fa fa-edit"></i> แก้ไข </button>
                    </td>
                  </tr>
              )
          });
      }

    return (
      <div className="card card-accent-info">
        <div className="card-header">
            <strong>ข้อมูลศูนย์ซ่อมบำรุง</strong>
        </div>
        <div className="card-block">
          <table className="table table-striped">
            <thead>
            <tr>
              <th className="text-left ">#</th>
              <th className="text-left">ศูนย์ซ่อมบำรุง</th>
              <th className="text-left">ที่อยู่</th>
              <th className="text-left">เบอร์โทรศัพท์</th>
              <th className="text-center"></th>
            </tr>
            </thead>
            <tbody>
            { centerList }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}